(() => {
  // app/scripts/product-card-carousel.js
  if (!customElements.get("product-childs")) {
    class productChilds extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      async init() {
        this.handleclick();
      }
      handleclick() {
        let productChilds2 = this.querySelectorAll(".jsProductChildChange");
        productChilds2[0].classList.add("active");
        productChilds2.forEach((child) => {
          child.addEventListener("click", () => {
            productChilds2.forEach((c) => {
              if (c.classList.contains("active")) {
                c.classList.remove("active");
              }
              child.classList.add("active");
            });
            this.productCard = child.closest("product-card");
            let target = child.querySelector(".product-child-media");
            this.productCard.querySelector(".card__media").innerHTML = target.innerHTML;
            const price = child.querySelector("[data-product-child-price]").innerHTML;
            this.productCard.querySelector(".product-card__price").innerHTML = price;
          });
        });
        setTimeout(() => {
          productChilds2[0].click();
        }, 300);
      }
    }
    customElements.define("product-childs", productChilds);
  }
})();
